<template>
  <div class="main-page-view-list">
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col :span="8">
        <el-image v-if="item.img" class="run-img" :src="item.img" :preview-src-list="[item.img]" preview-teleported="true" />
      </el-col>
      <el-col :span="15">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="run-title">
              {{ item.title }}
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="run-info-1">
              {{ item.date }}
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="run-info-2">
              {{ item.infoOne }}
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="run-info-2">
              {{ item.infoTwo }}
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="1"></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "runBlock",
  data() {
    return {}
  },
  props: ['item'],
  created() {

  },
}
</script>

<style scoped>
.main-page-view-list {
  margin-top: 10px;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
  transition: 1s;
}

.main-page-view-list::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-top: 2px solid #96e6a1;
  border-left: 2px solid #96e6a1;
  transition: 1s;
}

.main-page-view-list::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-right: 2px solid #96e6a1;
  border-bottom: 2px solid #96e6a1;
  transition: 1s;
}

.main-page-view-list:hover::before, .main-page-view-list:hover::after {
  width: 100%;
  height: 100%;
}

.main-page-view-list:hover {
  cursor: pointer;
  color: #42b8f1;
  background-color: #e7f5e1;
  box-shadow: 0 0 50px #e7f5e1;
  transition-delay: .5s;
}

.run-img {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
  height: 180px;
  z-index: 999;
}

.run-title {
  margin-top: 5px;
  font-size: 18px;
  font-weight: bold;
  color: #42b983;
  height: 30px;
  line-height: 30px;
}

.run-info-1 {
  margin-top: 5px;
  font-size: 16px;
  height: 25px;
  font-weight: bold;
  line-height: 25px;
  color: #42b8f1;
  font-family: 华文仿宋;
}

.run-info-2 {
  margin-top: 5px;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
  font-weight: bold;
  font-family: 华文仿宋;
}
</style>